import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LayoutService } from '@core/services/layout.service';

@Component({
  selector: 'app-quickpanel',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './quickpanel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Quickpanel {
  readonly layout = inject(LayoutService);
}
